<template>
  <router-view />
</template>

<script>
import { mapGetters } from 'vuex';
import Utils from '@/utils/utils';
import { saveLogInfo } from '@/apis/logInfo';
const PATH_MAP= {
  'underwritingStatus_1':'承销金额',
  'underwritingStatus_2':'公募承销情况',
  'underwritingStatus_3':'私募承销情况',
  'serviceBusiness_1':'服务企业家数',
  'serviceBusiness_2':'首发企业承销情况',
  'underwritingDistribution_1':'企业类型分布',
  'underwritingDistribution_2':'地域分布',
  'underwritingDistribution_3':'行业分布',
  'maturityDistribution':'期限分布',
  'specialProduct':'专项产品',
  'distributionSituation':'分销情况',
  'businessQualification':'业务资格情况',
  'bankDetail':'概况'
}
export default {
  name: 'App',
  components: {},
  data() {
    return {}
  
  },
  computed:{
    ...mapGetters({
      memInfo: 'memInfo/memDetail',
      tabInfo: 'memInfo/tabInfo',
      activeSubTab: 'memInfo/activeSubTab',
      userInfo:'user/userInfo'
    })
  },
  mounted() {    
    window.addEventListener('click',e=>this.handleClick(e))
  },
  methods:{
    handleClick(event){
      let {tag,label,trigger,path,year=''} = event.target.dataset
      if(tag&&label&&trigger){
        let params={
          userId:this.userInfo.userId,
          path,
          name:label,
          userName:this.userInfo.userName,
          userOrgName:this.userInfo.userOrgName,
          userOrgId:this.userInfo.userOrgId,
          startTime:Utils.dateFormat(new Date(),'YYYY-MM-DD hh:mm:ss'),
          endTime:'',
          type:tag,
          description:JSON.stringify({
            registerNumber:this.memInfo.registerNumber,
            bankSname:this.memInfo.bankSname,
            year:year,
            label
          })
        }
        this.handleLogIngo(params)
      }
    },
    handleLogIngo(params){
      return new Promise(async (resolve,reject)=>{
        await saveLogInfo({logInfo:params})
        resolve()
      })
    }
  },
  beforeDestroy(){
    window.removeEventListener('click',this.handleClick)
  }
};
</script>
<style>
#data_info_popover{
  left: 760px !important;
  top: 120px !important;
  background: #ffffff !important;
  width: 595px !important;
}
#data_info_popover .el-popper__arrow{
  left: 50% !important;
  transform: translateX(-50%) !important;
}
.el-dialog__header .el-dialog__headerbtn {
  background-position: 16px 15px !important;
}
</style>